import { values } from "mobx";
import { useStores } from "../stores/useStores";

export function useHeroTerrace(): IHeroTerraceBlock {
  const { gridStore } = useStores();
  return values(gridStore.blocks).find((b) => b.type === "hero");
}
